import autoBind from "auto-bind";
import { PostData } from "../../posts/post.models";
import { DateFormatter } from "../../utils/date_formatter";
import { DateRandomizer } from "../../utils/date_randomization";
import { DateGenerationStrategy } from "../generation.models";

export class PostDateGenerator {
  private randomizer: DateRandomizer;
  private formatter: DateFormatter;

  constructor(strategy: DateGenerationStrategy) {
    autoBind(this);
    this.formatter = new DateFormatter();
    this.randomizer = new DateRandomizer(
      strategy.min_offset,
      strategy.max_offset,
      strategy.increase_per_post
    );
  }

  addPostDates(posts: PostData[]): PostData[] {
    return posts.map((post) => {
      if (post.contentType == "filler" || post.contentType == "friend-post") {
        /// Friend posts appear as just posted since no comments.
        return { ...post, date: "Just now" };
      }

      const dateOffset = this.randomizer.next();

      return {
        ...post,
        date: this.formatter.formatOffsetAsDate(dateOffset),
        dateOffset: dateOffset,
      };
    });
  }
}
